import React, { useState, useEffect, useCallback } from "react";
import { Navigate } from "react-router-dom";
import { APIClient } from "../../../utils/APIClient";
import { API_URL } from "../../../settings/local_settings";
import { useFicha21 } from "../../../context/UserModulesContext";
import { ClientHeader } from "../ClientHeader";
import { ClientTabs } from "../ClientTabs";
import { ClientAgentArea } from "./ClientAgentArea";


export const ClientAgentContent = ({ clientId, sessionId }) => {
    const [name, setName] = useState('');
    const [businessUnits, setBusinessUnits] = useState(null);
    const [clientAdAccounts, setClientAdAccounts] = useState(null);
    // Con la ficha 2.1 Dashbito vive dentro del tab IA — esta ruta legacy redirige preservando la
    // sesión. En clásico NO redirige: el switch devuelve el tab Agente standalone.
    const { ficha21, loaded: modulesLoaded } = useFicha21();

    const fetchClientData = useCallback(() => {
        new APIClient(API_URL + 'client/' + clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                setName(data.data.name);
                setBusinessUnits(data.data.business_units || []);
                setClientAdAccounts(data.data.client_ad_accounts || []);
            }
        });
    }, [clientId]);

    useEffect(() => {
        fetchClientData();
    }, [fetchClientData]);

    // Esperar a que los módulos carguen antes de decidir: sin esto, un usuario de tier UX_21 sin
    // cache ve un flash de la pantalla legacy antes de que el redirect se dispare.
    if (!modulesLoaded) return null;

    if (ficha21) {
        const target = sessionId ? `dashbito/${sessionId}` : 'dashbito';
        return <Navigate to={`/client/${clientId}/ia/${target}`} replace/>;
    }

    return (
        <section className="section-content agent-area-wrapper">
            <ClientHeader name={name} />
            <ClientTabs clientId={clientId} />
            <ClientAgentArea
                clientId={clientId}
                sessionId={sessionId}
                adAccounts={clientAdAccounts}
                businessUnits={businessUnits}
            />
        </section>
    );
};
